import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import PublicationsService from "../../services/PublicationsService";
import Swal from "sweetalert2";
import $ from "jquery"
import { app_url } from "../../services/http";

import Select from "react-select";
import AuteursService from "../../services/AuteursService";
import { useSelector } from "react-redux";

export default function ShowPublications() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})
    const location = useLocation()
    const token = useSelector(state => state.auth.token)

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [typepublication_id, setTypePublication] = useState([])
    const [editeur_id, setEditeur] = useState([])
    const [auteur_id, setAuteur] = useState([])
    const [liste_auteurs, setListeAuteurs] = useState([])
    const [autre_auteur_id, setAutreAuteur] = useState([])
    const [titre_ouvrage, setTitreOuvrage] = useState('')
    const [prefacier, setPrefacier] = useState('')
    const [t_periodique, setTPeriodique] = useState('')
    const [titre_periodique, setTitrePeriodique] = useState('')
    const [sous_titre, setSousTitre] = useState('')
    const [categorie, setCategorie] = useState([])
    const [avant_propos, setAvantPropos] = useState([])
    const [mot_cle, setMotCle] = useState([])
    const [montant_publication_ouvrage, setMontantOuvrage] = useState('')
    const [montant_publication_periodique, setMontantPeriodique] = useState('')
    const [annee_publication, setAnneePublication] = useState('')
    const [collection_id, setCollection] = useState([])
    const [code_isbn, setCodeIsbn] = useState('')
    const [nbre_page, setNbrePage] = useState('')
    const [choix_pdf, setChoixPdf] = useState([])
    const [laune_path, setLaUne] = useState("")
    const [publication_path, setPublication] = useState()
    const [resume, setResume] = useState('')

    //get liste auteurs
    const fetchAuteurs = async () => {
        await AuteursService.index().then((res) => {
            setListeAuteurs(res.data.liste_auteurs)
        }).catch(error => {
            console.log(error)
        })

    }


    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.publications_edit, { state: { id: param } })
    }

    const show = async () => {
        await PublicationsService.show(location.state.id,token).then((response) => {
            setAnneePublication(response.data.publication.annee_publication)
            setCodeIsbn(response.data.publication.code_isbn)
            setTitreOuvrage(response.data.publication.titre_ouvrage)
            setTitrePeriodique(response.data.publication.titre_periodique)
            setResume(response.data.publication.resume)
            setNbrePage(response.data.publication.nbre_page)
            setTypePublication(response.data.publication.typepublication_id ? response.data.publication.type_libelle : "")
            setEditeur(response.data.publication.editeur_id ? response.data.publication.raison_sociale : "")
            setAuteur(response.data.publication.auteur_id ? response.data.publication.nom_auteur : "")
            setChoixPdf(response.data.publication.pdf_disponible === 0 ? "Non" : "Oui")
            setLaUne(response.data.publication.laune_path)
            setPublication(response.data.publication.publication_path ? response.data.publication.publication_path : "")
            setPrefacier(response.data.prefacier_info)
            setAvantPropos(response.data.avant_propos)
            //Selectionner par defaut les categories
            setCategorie(response.data.categories.length > 0 && response.data.categories.map((item) => ({
                value: item.categorie_id,
                label: item.get_categorie.libelle
            })))
            //Selectionner par defaut les mots_cles
            setMotCle(response.data.mots_cles.length > 0 && response.data.mots_cles.map((item) => ({
                value: item.motcle_id,
                label: item.get_motcle.libelle
            })))
            //Selectionner par defaut les autres_auteurs
            setAutreAuteur(response.data.autres_auteurs.length > 0 && response.data.autres_auteurs.map((item) => ({
                value: item.auteurs_id,
                label: item.get_coauteur.nom_auteur
            })))

            //Control sur le type publication pour afficher les champs cachés
            if (response.data.publication.typepublication_id === 1) { // ouvrage selected

                $("#show_sous_titre").removeClass("visually-hidden");
                setTitreOuvrage(response.data.publication.titre)
                setSousTitre(response.data.publication.sous_titre)
                // ajout de l'attribut required
                $("#sous_titre").attr("required", false);
                // auteur obligatoire 
                $("#id_auteur").attr("required", true);
                $("#auteur_rq").text("*");

                $("#show_sous_collection").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#collection").attr("required", false);
                setCollection(response.data.publication.collection_id ? response.data.publication.collection_libelle : "")

                $("#show_sous_montant").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#montant_publication").attr("required", true);
                setMontantOuvrage(response.data.publication.montant_publication)

                $("#show_titre_ouvrage").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#titre_ouvrage").attr("required", true);

                $("#show_sous_titre_periodique").addClass("visually-hidden");
                $("#titre_periodique").attr("required", false);
                $("#titre_periodique").val("");

                $("#show_sous_montant_periodique").addClass("visually-hidden");
                $("#montant_periodique").attr("required", false);
                $("#montant_periodique").val("");

                $("#show_titre_periodique").addClass("visually-hidden");
                $("#t_periodique").attr("required", false);
                $("#titre_periodique").attr("required", false);
                $("#titre_periodique").val("");

            } else if (response.data.publication.typepublication_id === 2) {
                $("#show_sous_titre_periodique").removeClass("visually-hidden");
                setTPeriodique(response.data.publication.titre)
                setTitrePeriodique(response.data.publication.titre_periodique)
                // ajout de l'attribut required
                $("#titre_periodique").attr("required", true);
                // auteur non obligatoire 
                $("#id_auteur").attr("required", false);
                $("#auteur_rq").text("");

                $("#show_sous_montant_periodique").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#montant_periodique").attr("required", true);
                setMontantPeriodique(response.data.publication.montant_publication)

                $("#show_titre_periodique").removeClass("visually-hidden");
                // ajout de l'attribut required
                $("#titre_periodique").attr("required", true);
                $("#t_periodique").attr("required", true);

                $("#show_sous_titre").addClass("visually-hidden");
                $("#sous_titre").attr("required", false);
                $("#sous_titre").val("");

                $("#show_sous_collection").addClass("visually-hidden");
                $("#collection").attr("required", false);
                $("#collection").val("");

                $("#show_sous_montant").addClass("visually-hidden");
                $("#montant_publication").attr("required", false);
                $("#montant_publication").val("");

                $("#show_titre_ouvrage").addClass("visually-hidden");
                $("#titre_ouvrage").attr("required", false);
                $("#titre_ouvrage").val("");

            } else {
                // si aucune valeur n'est sélectionné dans le champ type

                // auteur non obligatoire 
                $("#id_auteur").attr("required", false);
                $("#auteur_rq").text("");
            }

            //console.log(response.data.publication)

        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            setValidationError(error.erreur)
        });
    }


    useEffect(() => {
        show()
        fetchAuteurs()
        $("#submenu-1").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.publications_index} >Publications</Link></li>
                                        <li className="breadcrumb-item active">Détails Publication </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Détails
                                <span className="btn btn-primary btn-sm mx-3" onClick={() => goToEdit(location.state.id)} title="Ajouter" ><i className="fas fa-edit"></i></span></h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }}>
                                <Row>
                                    <Col md={3} lg={3} xl={4} className="border border-primary border-3">
                                        <Row>
                                            <Col md={12} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Couverture  <i className="text-danger"></i> &nbsp; (JPEG - PNG - JPG)
                                                    </Form.Label>
                                                    <div>
                                                        <Image src={laune_path ? app_url + "/storage/laune/" + laune_path : ""} className="w-75" />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col md={12} sm={12} className="form-group visually-hiddenx" id="show_publication">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Publication  <i className="text-danger"></i> &nbsp; (PDF)
                                                    </Form.Label>
                                                    <div>
                                                        <iframe src={publication_path ? app_url + "/storage/publications/" + publication_path : ""} height="100%" style={{ height: "75vh" }} width="100%" frameborder="0"></iframe>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={9} lg={9} xl={8}>
                                        <Row>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Type</Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={typepublication_id}
                                                        placeholder="Titre de l'ouvrage"
                                                        name="titre_ouvrage"
                                                        aria-label="titre_ouvrage"
                                                        type="text"
                                                        id="titre_ouvrage"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Editeur </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={editeur_id}
                                                        name="editeur_id"
                                                        aria-label="editeur_id"
                                                        type="text"
                                                        id="editeur_id"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Auteur </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={auteur_id}
                                                        name="auteur_id"
                                                        aria-label="auteur_id"
                                                        type="text"
                                                        id="auteur_id"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Autres auteur(s)
                                                    </Form.Label>
                                                    <Select id="autre_auteur"
                                                        isMulti
                                                        value={autre_auteur_id}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_titre_ouvrage">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Titre
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={titre_ouvrage}
                                                        placeholder="Titre de l'ouvrage"
                                                        name="titre_ouvrage"
                                                        aria-label="titre_ouvrage"
                                                        type="text"
                                                        id="titre_ouvrage"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_titre_periodique">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Titre de la périodique
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={t_periodique}
                                                        name="t_periodique"
                                                        aria-label="t_periodique"
                                                        type="text"
                                                        id="t_periodique"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_titre_periodique">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Titre complémentaire
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={titre_periodique}
                                                        placeholder="Titre de la périodique"
                                                        name="titre_periodique"
                                                        aria-label="titre_periodique"
                                                        type="text"
                                                        id="titre_periodique"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_titre">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Sous-titre <i className="text-danger"></i>
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={sous_titre}
                                                        placeholder="Sous titre"
                                                        name="sous_titre"
                                                        aria-label="sous_titre"
                                                        type="text"
                                                        id="sous_titre"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Préfacier </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={prefacier}
                                                        name="prefacier"
                                                        aria-label="prefacier"
                                                        type="text"
                                                        id="prefacier"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Avant-propos</Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={avant_propos}
                                                        name="avant_propos"
                                                        aria-label="avant_propos"
                                                        type="text"
                                                        id="avant_propos"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Catégorie(s) </Form.Label>
                                                    <Select id="categories"
                                                        required
                                                        isMulti
                                                        value={categorie}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Mots-clés
                                                    </Form.Label>

                                                    <Select id="tags"
                                                        isMulti
                                                        value={mot_cle}
                                                        disabled
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_montant">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Montant <i className="text-danger"></i></Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={montant_publication_ouvrage}
                                                        placeholder="Prix de l'ouvrage"
                                                        name="montant_publication_ouvrage"
                                                        aria-label="montant_publication_ouvrage"
                                                        type="number"
                                                        id="montant_publication"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_montant_periodique">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Montant périodique<i className="text-danger"></i></Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={montant_publication_periodique}
                                                        name="montant_publication_periodique"
                                                        aria-label="montant_publication_periodique"
                                                        type="text"
                                                        id="montant_publication_periodique"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6} sm={12} className="form-group visually-hidden" id="show_sous_collection">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Collection
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={collection_id}
                                                        name="collection_id"
                                                        aria-label="collection_id"
                                                        type="text"
                                                        id="collection_id"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={3} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Date de publication <i className="text-danger"></i>
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={annee_publication}
                                                        name="annee_publication"
                                                        aria-label="annee_publication"
                                                        type="number"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Code ISBN  <i className="text-danger"></i>
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={code_isbn}
                                                        name="code_isbn"
                                                        aria-label="code_isbn"
                                                        type="number"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nombre de page  <i className="text-danger"></i>
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={nbre_page}
                                                        name="nbre_page"
                                                        aria-label="nbre_page"
                                                        type="number"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={3} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>PDF Disponible ?  <i className="text-danger"></i>
                                                    </Form.Label>
                                                    <Form.Control className="border border-info border rounded-2"
                                                        value={choix_pdf}
                                                        readOnly
                                                        type="text"
                                                        id="publication"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12} sm={12} className="form-group">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Résumé / Sommaire  <i className="text-danger"></i> &nbsp; (PDF)
                                                    </Form.Label>
                                                    <textarea readOnly disabled value={resume} name="resume" id="" cols="30" rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>


                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}